/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Nutrtion from './nutrtion';
import NutrtionDetail from './nutrtion-detail';
import NutrtionUpdate from './nutrtion-update';
import NutrtionDeleteDialog from './nutrtion-delete-dialog';

const NutrtionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Nutrtion />} />
    <Route path="new" element={<NutrtionUpdate />} />
    <Route path=":id">
      <Route index element={<NutrtionDetail />} />
      <Route path="edit" element={<NutrtionUpdate />} />
      <Route path="delete" element={<NutrtionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutrtionRoutes;
